/**
 * The box a dropdown rooted at `el` opens from, or null when it has none.
 *
 * An editable grid cell marks its field box with `data-dropdown-anchor`: a trigger inside the cell
 * is only as tall as its content and sits centred in the row, so a popover placed under the
 * trigger lands inside the cell, over the text it is meant to sit below. The field box ends at the
 * underline the user sees.
 *
 * A `[popover]` on the way up ends the search, so a dropdown nested in another one's popover still
 * opens from its own trigger.
 */
export function findDropdownAnchor(el: HTMLElement | null | undefined): HTMLElement | null {
  const match = el?.closest("[data-dropdown-anchor], [popover]");
  return match instanceof HTMLElement && match.hasAttribute("data-dropdown-anchor") ? match : null;
}
